export const reserchAndConsultancyUrl = 'http://research.ljramos.com.ar'
export const corporativeServicesUrl = 'http://servicioscorporativos.ljramos.com.ar'



// WEBPACK FOOTER //
// ./src/constants/index.js